import { axiosInstance as axios } from '3-foundation/ContentApi/axiosInstance';
import logger from '3-foundation/Logging/logger';
import { queryContentApi } from '3-foundation/ContentApi/queryContentApi';

//CMS is not exposed to the website, therefore we fetch the news via a Next.JS API
export const getNewsFromApi = async (
	rootId: number,
	limit: number,
	offset: number,
	preview: boolean,
	previewData: Content.PreviewData,
): Promise<News.NewsArticle[]> => {
	return axios({
		url: `/api/news`,
		method: 'POST',
		headers: {},
		data: {
			rootId,
			limit,
			offset,
			preview,
			previewData,
		},
	})
		.then((res) => {
			const articles: News.NewsArticle[] = res.data?.newsArticles;
			return articles;
		})
		.catch((error) => {
			const message = error?.response?.data?.message ?? error;
			logger.error(`getNewsFromApi() \nNews retrieval from API failed \n${message}`);
			throw message;
		});
};

export const getNewsFromCms = async (
	rootId: number,
	limit: number,
	offset: number,
	preview: boolean,
	previewData: Content.PreviewData,
): Promise<News.NewsArticle[]> => {
	const graphQLquery = `{
		pageSearch(documentType:["newsPage"] rootIds:[${rootId}] limit:${limit} offset:${offset} orderDesc:"createDate")
			{
				pages {
					name
					url
					id
					properties
				}
			}
		}`;

	const profiler = logger.startTimer();
	try {
		const results: {
			pageSearch: {
				pages: ({
					properties: { newsHeading: string; newsKicker: string; newsTeaser: string; newsDate: string; image: Content.Image };
				} & Content.Page)[];
			};
		} = await queryContentApi({
			query: graphQLquery,
			preview,
			previewData,
			method: 'POST',
		});

		const articles = results.pageSearch?.pages.map((page) => ({
			heading: page.properties.newsHeading,
			url: page.url,
			kicker: page.properties.newsKicker,
			text: page.properties.newsTeaser,
			date: page.properties.newsDate !== null ? new Date(page.properties.newsDate).toDateString() : null,
			image: page.properties.image,
		}));
		return articles;
	} finally {
		profiler.done({ message: 'getNews', level: 'debug' });
	}
};
